import React, { useState } from 'react';
import { Trash2, ArrowRight, ArrowLeft, ShoppingBag, User, Truck, CheckCircle, Minus, Plus } from 'lucide-react';
import './Cartview.css';

const ubicaciones = {
  "Lima": {
    "Miraflores": { tarifa: 10 },
    "San Isidro": { tarifa: 10 },
    "Barranco": { tarifa: 10 },
    "San Borja": { tarifa: 12 },
    "Surco": { tarifa: 12 },
    "La Molina": { tarifa: 15 },
    "Ate": { tarifa: 15 },
    "Santa Anita": { tarifa: 15 },
    "San Juan de Lurigancho": { tarifa: 18 },
    "Chorrillos": { tarifa: 12 },
    "San Miguel": { tarifa: 10 },
    "Magdalena": { tarifa: 10 },
    "Lince": { tarifa: 10 },
    "Jesús María": { tarifa: 10 },
    "Pueblo Libre": { tarifa: 10 },
    "Villa el Salvador": { tarifa: 18 },
    "Villa Maria del Triunfo": { tarifa: 18 },
    "San Juan de Miraflores": { tarifa: 15 }
  },
  "Callao": {
    "Callao Cercado": { tarifa: 20 },
    "Bellavista": { tarifa: 20 },
    "La Perla": { tarifa: 20 },
    "La Punta": { tarifa: 20 },
    "Carmen de la Legua": { tarifa: 20 },
    "Ventanilla": { tarifa: 25 }
  }
};

const Cartview = ({ cart, setCart, onClose }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [errors, setErrors] = useState({});
  const [customerData, setCustomerData] = useState({
    nombre: '',
    dni: '',
    telefono: '',
    correo: '',
    provincia: 'Lima',
    distrito: '',
    direccion: '',
    referencia: '',
    tipoEntrega: 'delivery' // 'delivery' o 'recojo'
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCustomerData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const removeFromCart = (id) => {
    setCart(cart.filter(item => item.id !== id));
  };

  const clearCart = () => {
    if (window.confirm('¿Estás seguro de que deseas vaciar todo el carrito?')) {
      setCart([]);
    }
  };

  const updateQuantity = (id, delta) => {
    setCart(cart.map(item => {
      if (item.id === id) {
        const newQty = Math.max(1, item.quantity + delta);
        return { ...item, quantity: newQty, totalPrice: newQty * parseFloat(item.price || item.precio) };
      }
      return item;
    }));
  };

  const subtotal = cart.reduce((sum, item) => sum + (item.totalPrice), 0);
  const envioBase = customerData.tipoEntrega === 'delivery' && customerData.distrito
    ? (ubicaciones[customerData.provincia]?.[customerData.distrito]?.tarifa || 0)
    : 0;
  const total = subtotal + envioBase;

  const validateStep = (step) => {
    const newErrors = {};
    if (step === 2) {
      if (!customerData.nombre.trim()) newErrors.nombre = 'El nombre es obligatorio';
      if (!/^\d{8}$/.test(customerData.dni)) newErrors.dni = 'DNI debe tener 8 dígitos';
      if (!/^\d{9}$/.test(customerData.telefono)) newErrors.telefono = 'Teléfono debe tener 9 dígitos';
    } else if (step === 3) {
      if (customerData.tipoEntrega === 'delivery') {
        if (!customerData.distrito) newErrors.distrito = 'Selecciona tu distrito';
        if (!customerData.direccion.trim()) newErrors.direccion = 'La dirección es obligatoria';
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (validateStep(currentStep)) {
      setCurrentStep(prev => prev + 1);
    }
  };

  const handleWhatsAppCheckout = () => {
    if (!validateStep(3)) return;

    let message = `*🌿 NUTRI MAYRA - NUEVO PEDIDO*\n\n`;
    message += `*DATOS DEL CLIENTE:*\n`;
    message += `👤 *Nombre:* ${customerData.nombre}\n`;
    message += `🆔 *DNI:* ${customerData.dni}\n`;
    message += `📞 *WhatsApp:* ${customerData.telefono}\n\n`;

    message += `*MODALIDAD DE ENTREGA:*\n`;
    message += `🚚 *Tipo:* ${customerData.tipoEntrega === 'delivery' ? 'Delivery a Domicilio' : 'Recojo en Local'}\n`;

    if (customerData.tipoEntrega === 'delivery') {
      message += `📍 *Lugar:* ${customerData.provincia} - ${customerData.distrito}\n`;
      message += `🏠 *Dirección:* ${customerData.direccion}\n`;
      message += `🏢 *Ref:* ${customerData.referencia || 'Sin referencia'}\n\n`;
    } else {
      message += `📍 *Sede de recojo:* Miraflores, Lima (Coordinar horario)\n\n`;
    }

    message += `*PRODUCTOS SOLICITADOS:*\n`;
    cart.forEach(item => {
      message += `✅ ${item.nombre} (x${item.quantity}) - S/. ${item.totalPrice.toFixed(2)}\n`;
    });

    message += `\n*RESUMEN DE PAGO:* \n`;
    message += `--------------------------\n`;
    message += `Subtotal: S/. ${subtotal.toFixed(2)}\n`;
    message += `Envío: S/. ${envioBase.toFixed(2)}\n`;
    message += `*TOTAL A PAGAR: S/. ${total.toFixed(2)}*\n`;
    message += `--------------------------\n\n`;
    message += `_Por favor, confírmame el pedido y envíame los datos para realizar el pago._`;

    const phoneNumber = '51923651512';
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`, '_blank');

    // Cerrar el modal después de un pequeño delay
    setTimeout(() => {
      onClose();
    }, 500);
  };

  return (
    <div className="cart-container">
      <div className="cart-header">
        <div className="cart-steps">
          <div className={`cart-step ${currentStep === 1 ? 'active' : 'done'}`}>
            <ShoppingBag /> <span>Carrito</span>
          </div>
          <div className={`cart-step ${currentStep === 2 ? 'active' : currentStep > 2 ? 'done' : ''}`}>
            <User /> <span>Tus Datos</span>
          </div>
          <div className={`cart-step ${currentStep === 3 ? 'active' : ''}`}>
            <Truck /> <span>Envío</span>
          </div>
        </div>
      </div>

      <div className="cart-scroll-area">
        {currentStep === 1 && (
          <div className="cart-items-step">
            {cart.length === 0 ? (
              <div className="empty-state">
                <ShoppingBag size={48} />
                <p>Tu carrito está vacío</p>
                <button onClick={onClose} className="btn-back">Volver a la tienda</button>
              </div>
            ) : (
              <div className="cart-list-wrapper">
                <div className="cart-list-header">
                  <span>Tus Productos ({cart.length})</span>
                  <button className="btn-clear-cart" onClick={clearCart}>Vaciar Carrito</button>
                </div>
                <div className="cart-items-list">
                  {cart.map(item => (
                    <div key={item.id} className="checkout-item">
                      <img src={item.imagen} alt={item.nombre} />
                      <div className="checkout-info">
                        <h3>{item.nombre}</h3>
                        <p className="checkout-price">S/. {parseFloat(item.precio).toFixed(2)}</p>
                        <div className="checkout-qty-control">
                          <button onClick={() => updateQuantity(item.id, -1)}><Minus size={14} /></button>
                          <span>{item.quantity}</span>
                          <button onClick={() => updateQuantity(item.id, 1)}><Plus size={14} /></button>
                        </div>
                      </div>
                      <button onClick={() => removeFromCart(item.id)} className="btn-remove" title="Eliminar">
                        <Trash2 size={18} />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}

        {currentStep === 2 && (
          <div className="cart-form-step">
            <div className="step-heading">
              <h3>Información Personal</h3>
              <p>Necesaria para tu boleta e identificación</p>
            </div>
            <div className="input-group">
              <label>Nombre Completo * {errors.nombre && <span className="error-text">{errors.nombre}</span>}</label>
              <input
                type="text"
                name="nombre"
                value={customerData.nombre}
                onChange={handleInputChange}
                placeholder="Como figura en tu DNI"
                className={errors.nombre ? 'error-input' : ''}
              />
            </div>
            <div className="input-row">
              <div className="input-group">
                <label>DNI * {errors.dni && <span className="error-text">{errors.dni}</span>}</label>
                <input
                  type="text"
                  name="dni"
                  value={customerData.dni}
                  onChange={handleInputChange}
                  maxLength="8"
                  placeholder="8 dígitos"
                  className={errors.dni ? 'error-input' : ''}
                />
              </div>
              <div className="input-group">
                <label>WhatsApp * {errors.telefono && <span className="error-text">{errors.telefono}</span>}</label>
                <input
                  type="tel"
                  name="telefono"
                  value={customerData.telefono}
                  onChange={handleInputChange}
                  placeholder="999888777"
                  className={errors.telefono ? 'error-input' : ''}
                />
              </div>
            </div>
            <div className="input-group">
              <label>Correo Electrónico {errors.correo && <span className="error-text">{errors.correo}</span>}</label>
              <input
                type="email"
                name="correo"
                value={customerData.correo}
                onChange={handleInputChange}
                placeholder="ejemplo@correo.com"
                className={errors.correo ? 'error-input' : ''}
              />
            </div>
          </div>
        )}

        {currentStep === 3 && (
          <div className="cart-form-step">
            <div className="step-heading">
              <h3>Detalles de Entrega</h3>
              <p>¿Cómo prefieres recibir tu pedido?</p>
            </div>

            <div className="delivery-type-selector">
              <label className={`delivery-option ${customerData.tipoEntrega === 'delivery' ? 'selected' : ''}`}>
                <input
                  type="radio"
                  name="tipoEntrega"
                  value="delivery"
                  checked={customerData.tipoEntrega === 'delivery'}
                  onChange={handleInputChange}
                />
                <div className="option-content">
                  <Truck size={20} />
                  <span>Delivery a Domicilio</span>
                </div>
              </label>

              <label className={`delivery-option ${customerData.tipoEntrega === 'recojo' ? 'selected' : ''}`}>
                <input
                  type="radio"
                  name="tipoEntrega"
                  value="recojo"
                  checked={customerData.tipoEntrega === 'recojo'}
                  onChange={handleInputChange}
                />
                <div className="option-content">
                  <User size={20} />
                  <span>Recojo en Local</span>
                </div>
              </label>
            </div>

            {customerData.tipoEntrega === 'delivery' ? (
              <div className="delivery-fields">
                <div className="input-row">
                  <div className="input-group">
                    <label>Provincia</label>
                    <select name="provincia" value={customerData.provincia} onChange={handleInputChange}>
                      <option value="Lima">Lima</option>
                      <option value="Callao">Callao</option>
                    </select>
                  </div>
                  <div className="input-group">
                    <label>Distrito * {errors.distrito && <span className="error-text">{errors.distrito}</span>}</label>
                    <select
                      name="distrito"
                      value={customerData.distrito}
                      onChange={handleInputChange}
                      className={errors.distrito ? 'error-input' : ''}
                    >
                      <option value="">Selecciona distrito</option>
                      {Object.keys(ubicaciones[customerData.provincia]).map(d => (
                        <option key={d} value={d}>{d}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="input-group">
                  <label>Dirección de entrega * {errors.direccion && <span className="error-text">{errors.direccion}</span>}</label>
                  <input
                    type="text"
                    name="direccion"
                    value={customerData.direccion}
                    onChange={handleInputChange}
                    placeholder="Calle, Av, Número, Dpto..."
                    className={errors.direccion ? 'error-input' : ''}
                  />
                </div>
                <div className="input-group">
                  <label>Referencia</label>
                  <input type="text" name="referencia" value={customerData.referencia} onChange={handleInputChange} placeholder="Color de casa, frente a..." />
                </div>
                <div className="shipping-notice">
                  <div className="notice-icon"><CheckCircle size={16} /></div>
                  <p>Llegará en 24-48h hábiles tras confirmación.</p>
                </div>
              </div>
            ) : (
              <div className="recojo-info">
                <div className="recojo-card">
                  <h4>Sede Miraflores</h4>
                  <p>Coordinaremos contigo el horario exacto para el recojo tras confirmar el pedido.</p>
                </div>
                <div className="shipping-notice success">
                  <div className="notice-icon"><CheckCircle size={16} /></div>
                  <p>¡Costo de envío GRATIS al recoger en local!</p>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      <div className="cart-footer">
        <div className="cart-summary">
          <div className="summary-line">
            <span>Subtotal:</span>
            <span>S/. {subtotal.toFixed(2)}</span>
          </div>
          <div className="summary-line">
            <span>Envío:</span>
            <span>{customerData.tipoEntrega === 'recojo' ? 'GRATIS' : (envioBase > 0 ? `S/. ${envioBase.toFixed(2)}` : 'Calculado en paso 3')}</span>
          </div>
          <div className="summary-line grand-total">
            <span>Total a pagar:</span>
            <span>S/. {total.toFixed(2)}</span>
          </div>
        </div>

        <div className="cart-nav-buttons">
          {currentStep > 1 && (
            <button className="btn-secondary" onClick={() => setCurrentStep(prev => prev - 1)}>
              <ArrowLeft size={18} /> Atrás
            </button>
          )}
          {currentStep < 3 && cart.length > 0 && (
            <button className="btn-primary" onClick={handleNext}>
              Siguiente <ArrowRight size={18} />
            </button>
          )}
          {currentStep === 3 && (
            <button className="btn-whatsapp" onClick={handleWhatsAppCheckout}>
              Confirmar pedido por WhatsApp
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Cartview;
